// @flow

export type PlaceOrderErrorPayload = {|
  code: string,
  message: string,
|};

export class PlaceOrderError extends Error {
  payload: PlaceOrderErrorPayload;

  constructor(payload: PlaceOrderErrorPayload, ...params: any) {
    super(...params);
    this.payload = payload;
  }
}
